module.exports = __webpack_public_path__ + "img/banner-referral-belanja.96a6af62.webp";